import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function WorkflowAction() {

    return (
        <div>


            <DHeader>Actions</DHeader>
       

            <DText>
            Each step in a workflow is a function that takes in inputs, runs a computation and returns outputs. Each function in Laeyerz  is modelled as an Action. An Action is created using
            </DText>

            <DCode>
                {`newAction = Action(action_name=action_name, 
function=function, 
inputs=inputs,
parameters=parameters, 
outputs=outputs, 
description=description)`}
            </DCode>


            <DText>
            Actions also form the basis of Tools used when building Agents.

In Laeyerz, Actions are not used directly. They are built into Nodes, which form the basic building blocks of the workflow. As we explore Nodes next, you will learn the reason for this and see how the functions defined in our workflow above are converted into Nodes.
            </DText>

           
      
       
        </div>
    )
}